<style src="./style.scss">
</style>

<script>
  import { onMount } from "svelte";

  import Button from "@components/button";
  import Header from "@components/header";
  import TextInput from "@components/textInput";
  import Toast from "@components/toast";
  import Icon from "svelte-icon";
  import SuccessVideo from "@assets/videos/success-animation.mp4";
  import { mutation } from "svelte-apollo";

  import { Router, Link, Route } from "svelte-navigator";
  import { navigate, useLocation } from "svelte-navigator";

  import { email as storedEmail, authType } from "@store";
  import { parseQuery, generateCaptchaTokenOnSubmit } from "@utils";

  import { captureException } from '@integrations/sentry.ts';

  import { CREATE_ACCOUNT_MUTATION } from "./createAccount.mutation.ts";

  import { saveToken } from "@services/auth";

  const location = useLocation();

  const queryParams = parseQuery($location.search);

  const { email } = queryParams;

  if (!email) {
    navigate("/");
  }

  export let password = "";
  export let passwordConfirm = "";
  export let isFetching = false;

  let passwordFieldError = false;

  const createAccount = mutation(CREATE_ACCOUNT_MUTATION);

  let message = {
    visible: false,
    text: "",
    toastType: "",
    size: "small",
  };

  onMount(() => {
    const video = document.querySelector("video");

    video.play();
  });

  function showMessage(
    text,
    toastType,
    size
  ) {
    message = {
      toastType,
      text,
      visible: true,
      size: size || "small",
    };
  }

  function clearMessage() {
    passwordFieldError = false;
    message = { visible: false, text: "", toastType: "alert" };
  }

  async function submit() {
    if (password !== passwordConfirm) {
      showMessage("As senhas não conferem.", "alert");
      passwordFieldError = true;
      return;
    }

    if (password.length < 6) {
      showMessage("Cadastre uma senha com no mínimo 6 caracteres.", "alert");
      passwordFieldError = true;
      return;
    }

    isFetching = true;

    try {
      const { data, errors } = await createAccount({
        variables: {
          input: {
            email,
            password,
            passwordConfirmation: passwordConfirm,
          },
        },
      });

      isFetching = false;

      const token = data?.createAccount?.accessToken;

      if (token) {
        saveToken(token);
        const nextRoute = $location.state.redirectRoute || "/checkout-success";

        navigate(
          $location.state.successRedirectURL
            ? $location.state.successRedirectURL
            : nextRoute
        );

        return;
      }
    } catch {
      isFetching = false;
      showMessage("Desculpe, tente mais tarde.", "alert");

      return;
    }
  }
</script>

<Header steps="{[1, 2, 3]}" activeStep="{1}" checkedStep="{0}" />

<div class="create-account">
  <div class="create-account__content">
    <Toast
      message="{message.text}"
      toastType="{message.toastType}"
      visible="{message.visible}"
      size="{message.size}"
      onClose="{clearMessage}" />

    <div class="create-account__content__icon">
      <video preload="auto" muted playsinline>
        <source src="{SuccessVideo}" type="video/mp4" />
      </video>
    </div>
    <h1>Assinatura confirmada!</h1>

    <div class="divisor"></div>

    <h2>Crie a sua senha para usar sua conta</h2>

    <form on:submit|preventDefault="{submit}">
      <TextInput
        label="Senha"
        placeholder="Senha"
        disabled="{isFetching}"
        error="{passwordFieldError}"
        bind:value="{password}"
        passwordInput="{true}"
        emptyMessage="A senha está em branco." />

      <TextInput
        label="Confirmar senha"
        placeholder="Confirmar senha"
        disabled="{isFetching}"
        emptyMessage="A senha está em branco."
        bind:value="{passwordConfirm}"
        error="{passwordFieldError}"
        passwordInput="{true}" />

      <div class="button-container">
        <Button
          title="{isFetching ? 'Aguarde' : 'Continuar'}"
          disabled="{!password || isFetching}" />
      </div>
    </form>
  </div>
</div>
